export default {
  name: 'securitySetting',
  data() {
    return {
      securityFrom: {
        password: '123456',
        payPassword: '88888888',
        phone: '13*****6666',
        bankCard: '422*************125',
        wechat: 'Live'
      },
      showPhone: false,
      passwordStatus: 'change',
      securityRule: {}
    };
  },
  methods: {
    changePassword(val) {
      this.passwordStatus = val;
      if (val == 'save') {
        this.$refs.password.focus();
      }
    },
    changeEye() {
      this.showPhone = !this.showPhone;
    }
  }
};